module.exports = __webpack_public_path__ + "static/5- Lilium superbum-2d1cf9ad4adf4dd4c60267249be9e7e9.jpg";